import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './rich-text-modal.component.scss';
import * as $ from 'jquery';
var RichTextModal = /** @class */ (function (_super) {
    tslib_1.__extends(RichTextModal, _super);
    function RichTextModal(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    RichTextModal.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-rich-text-modal-modal-open'));
        this.closeButton = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal-close'));
    };
    RichTextModal.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.closeButton.map(function (item) { return item.addEventListener('click', function (event) {
            _this.closeModal();
        }); });
        // this.closeButton.addEventListener('click', (event) => this.closeModal());
    };
    RichTextModal.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    RichTextModal.prototype.closeModal = function () {
        var _this = this;
        if (this.activeModal) {
            this.activeModal.classList.add('modal--close');
        }
        else {
            this.activeModal = this.element.querySelector('.js-rich-text-modal-modal--opened');
            this.activeModal.classList.add('modal--close');
        }
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    RichTextModal.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-rich-text-modal-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    RichTextModal.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    RichTextModal.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    return RichTextModal;
}(Base));
export { RichTextModal };



//////////////////
// WEBPACK FOOTER
// ./components/rich-text-modal/rich-text-modal.component.ts
// module id = 483
// module chunks = 0